<template>
    <div class="container-prop-component">
      <div class="items-group">
        <p class="dr-dp-component-group-header" v-if="objectName != undefined">{{$t(objectName)}}</p>
        <template v-for="(prop, index) in schema">
          <component
            :readonly="readonly"
            :is="choiceComponent(prop)"
            :key="index"
            :propName="index"
            :value="localValue[index]"
            :schema="getSchema(prop)"
            :objectName="getObjectName(prop)"
            v-if="index != '$ID'"
            @input="changeValue(index, $event)"
            @change="$emit('change', localValue)"
          ></component>
        </template>
      </div>
    </div>
</template>
<script>
export default {
  name: 'dr-property-object-field',
  props: ['schema', 'propName', 'value', 'objectName', 'readonly'],
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    changeValue(index, value) {
      let newValue = { ...this.localValue }
      newValue[index] = value
      this.localValue = newValue
    },
    choiceComponent(prop) {
      if (prop.type == 'boolean') {
        return 'dr-property-check-box'
      }
      if (prop.enum) {
        return 'dr-property-select'
      }
      if (prop.component) {
        return prop.component
      }
      if (prop.type == 'object') {
        return 'dr-property-object-field'
      }
      if (prop.type == 'array') {
        return
      }
      // для остальных создаем простые текстовые поля
      return 'dr-property-text-field'
    },
    getSchema(prop) {
      if (prop.type == 'object') {
        return prop.properties
      }
      return prop
    },
    getObjectName(prop) {
      if (prop.type == 'object' && 'name' in prop) {
        return prop.name
      }
      return undefined
    }
  }
}
</script>
<style scoped>
.items-group {
  border: 1px solid lightgray;
  border-radius: 4px;
  padding: 0px 3px 0px 3px;
}
</style>

